import { useNavigate } from 'react-router-dom';

import { MarkdownContent as Base, MarkdownContentProps } from '@cavela/ui';

import ImageGallery from 'src/shared/components/ImageGallery';

/**
 * Thin frontend shim around the shared MarkdownContent from @cavela/ui.
 * Pre-configures navigate and the app's ImageGallery so no existing callers
 * need to change.
 */
const MarkdownContent: React.FC<MarkdownContentProps> = (props) => {
  const navigate = useNavigate();

  return (
    <Base
      navigate={navigate}
      renderImages={(imageUrls) =>
        imageUrls.length > 0 ? (
          <ImageGallery imageUrls={imageUrls} isXL />
        ) : null
      }
      {...props}
    />
  );
};

export default MarkdownContent;
